import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startTimer, updateTimer } from '../Redux/Slices/timerSlice';
import { RootState, AppDispatch } from '../Redux/Store/Store';

interface TimerProps {
  id: string;
  durationInSeconds?: number; // Optional for count-up timers
  isCountUp?: boolean; // Optional prop, defaults to false
  type?: string;
  order?: string
}

const NewTimer: React.FC<TimerProps> = ({ id, durationInSeconds, isCountUp = false, type = "normal", order = "VERBAL_QUANT"}) => {
  const dispatch = useDispatch<AppDispatch>();
  const timer = useSelector((state: RootState) => state.timers[id]);
  const [isBlinking,setIsBlinking] = useState(false)

  useEffect(() => {
    if (!timer) {
      dispatch(startTimer({ id, duration: durationInSeconds, isCountUp }));
    }

    const interval = setInterval(() => {
      dispatch(updateTimer({ id }));
    }, 1000);

    return () => clearInterval(interval);
  }, [dispatch, id, timer, durationInSeconds, isCountUp]);

  const Genraltimes = (seconds: number,type:string,order:string) : number => {
    switch (type) {
      case "GENERAL":
        if (seconds > 6000) return seconds - 6000 
        else if(seconds > 3900) return seconds - 3900 
        else if(seconds > 2100) return seconds - 2100 
        else return seconds

      case "GENERAL2":
        if (order === "VERBAL_QUANT") {
          if (seconds > 7800) return seconds - 7800
          else if (seconds > 6000) return seconds - 6000 
          else if(seconds > 3900) return seconds - 3900 
          else if(seconds > 2100) return seconds - 2100 
          else return seconds
        } else {
          if (seconds > 7800) return seconds - 7800
          else if (seconds > 5700) return seconds - 5700 
          else if(seconds > 3900) return seconds - 3900 
          else if(seconds > 1800) return seconds - 1800 
          else return seconds
        }

      case "GENERAL1":
        if (order === "VERBAL_QUANT") {
          if (seconds > 5280) return seconds - 5280
          else if (seconds > 4200) return seconds - 4200 
          else if(seconds > 2940) return seconds - 2940 
          else if(seconds > 1560) return seconds - 1560 
          else return seconds
        } else {
          if (seconds > 5280) return seconds - 5280
          else if (seconds > 4020) return seconds - 4020 
          else if(seconds > 2940) return seconds - 2940 
          else if(seconds > 1380) return seconds - 1380 
          else return seconds
        }
    
      default:
        return seconds
    }
    
  }

  const formatTime = (seconds: number): string => {
    const new_time = type.includes('GENERAL') ? Genraltimes(seconds,type,order) : seconds;
    //blink
    if (!timer.isCountUp && new_time < 300 && new_time > 294 && !isBlinking) setIsBlinking(true)
    else if(!timer.isCountUp && new_time < 294 && isBlinking) setIsBlinking(false)

    const minutes = Math.floor(new_time / 60);
    const secs = new_time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const time = timer
    ? timer.isCountUp
      ? timer.elapsedTime ?? 0
      : timer.remainingTime ?? durationInSeconds
    : 0;

  return (
    <span className={isBlinking ? 'blink' : ''}>
      {time ? formatTime(time) : '00:00'}
    </span>
  );
};

export default NewTimer;